.greyBackground {
    background-color: #e4e9eb;
}

.blueMountainBackground {
    background-image: url('/sm_mountainBkgrd.jpg');
    background-size: cover;
    background-repeat: no-repeat;
}

.whiteBackground {
    background-color: rgba(247, 247, 247, 0.89);
}
